import CheckboxField from './checkbox-field';

class TogglerField extends CheckboxField {}

export default TogglerField;
